// ---------------------------------------------------------------------------
// Hero Renderer
// ---------------------------------------------------------------------------
// Marketing primitive — publishes the editor `Hero` block (the local
// editor-only counterpart distinct from the storefront `hero-section`) as
// a centred banner with title, subtitle, and a single CTA. Distinct from
// the canonical `hero-section` block: this is the slim Wave-1 marketing
// hero used on simple landing pages without background imagery.

import { registerRenderer } from "../registry.js";
import type { RenderContext } from "../types.js";
import { attr, text, url } from "../escape.js";

interface HeroProps {
  title?: string;
  subtitle?: string;
  ctaLabel?: string;
  ctaUrl?: string;
}

function render(props: Record<string, unknown>, _ctx: RenderContext): string {
  const p = props as HeroProps;

  const title = typeof p.title === "string" ? p.title.trim() : "";
  if (!title) {
    return "<!-- hero missing title -->";
  }

  const subtitle = typeof p.subtitle === "string" ? p.subtitle.trim() : "";
  const ctaLabel = typeof p.ctaLabel === "string" ? p.ctaLabel.trim() : "";
  const rawCtaUrl = typeof p.ctaUrl === "string" ? p.ctaUrl.trim() : "";

  const subtitleHtml = subtitle
    ? `\n    <p class="ease-hero__subtitle">${text(subtitle)}</p>`
    : "";

  const ctaHtml = ctaLabel
    ? `\n    <a class="ease-hero__cta ease-btn ease-btn-primary" href="${url(rawCtaUrl || "#")}">${text(ctaLabel)}</a>`
    : "";

  return `<section class="ease-section ease-hero" style="text-align: ${attr("center")};">
  <div class="ease-hero__inner">
    <h1 class="ease-hero__title">${text(title)}</h1>${subtitleHtml}${ctaHtml}
  </div>
</section>`;
}

registerRenderer("hero", { render });
